export default __webpack_public_path__ + "static/char-s-05-en-0a5ab966a2d4ac97c52732735dde1712.webp";